import { Table, get, TextBody, Button, Label, Box } from '@ally/metronome-ui'
import styled from 'styled-components'

export const StyledUl = styled.ul`
  padding-inline-start: ${get.space('sm')};

  li {
    margin-bottom: ${get.space('xs')};
    line-height: ${get.space('md')};
    color: ${get.colors('slate-5')};
  }
`
export const StkBucketCardsWrapper = styled.div`
  display: grid;
  grid-gap: ${get.space('xs')};
  margin-bottom: ${get.space('md')};
  grid-template-columns: repeat(auto-fit, minmax(100px, 200px));
`
// Crunch the Numbers booster tile wrapper
/* istanbul ignore next */
export const CrunchNumbersTileWrapper = styled.li<{
  isCheckedOrEnrolled: boolean
}>`
  ${({ isCheckedOrEnrolled, theme }): string =>
    `position: relative;
    height: ${isCheckedOrEnrolled ? `260px` : `max-content`};
    min-height: ${isCheckedOrEnrolled ? `260px` : `max-content`};
    display: flex;
    flex-direction: column;
    align-content: space-between;
    justify-content: space-between;
    width: 100%;
    border: ${
      isCheckedOrEnrolled
        ? `1px solid ${theme.colors['slate-2']}`
        : `2px dashed ${theme.colors['slate-2']}`
    };
    box-shadow: ${
      isCheckedOrEnrolled ? `0 4px 0 0 ${theme.colors['slate-2']}` : `none`
    };
    border-radius: ${isCheckedOrEnrolled ? `5px 5px 10px 10px` : `5px`};
    margin-right: ${theme.space.sm};
    margin-top: ${theme.space.sm};
    padding: 0 ${theme.space.sm};
    padding-bottom: ${theme.space.lg};
    &.recurring-transfers-tile {
      ${theme.media.down('lg')} {
        height: ${isCheckedOrEnrolled ? `290px` : `max-content`};
        min-height: ${isCheckedOrEnrolled ? `290px` : `max-content`};
      }
    }
    ${theme.media.up('lg')} {
      width: 40%;
      margin-right: ${theme.space.lg};
    }
    ${theme.media.up('xl')} {
      width: 30%;
    }
    `}
`

export const StyledTable = styled(Table)`
  th {
    white-space: nowrap;
  }
`

export const StyledTextBody = styled(TextBody)`
  white-space: nowrap;
`

export const StyledTextBodyErrorColor = styled(TextBody)`
  color: ${get.colors('error')};
`

export const StyledTextBodyCenterAlign = styled(TextBody)`
  text-align: center;
`

export const StyledLabelMarginBottom = styled(Label)`
  label {
    margin-bottom: ${get.space('lg')} !important;
  }
`

export const StyledDescription = styled(TextBody)`
  white-space: break-spaces;
  text-align: left;
`

export const StyledButton = styled(Button)`
  white-space: break-spaces;
  text-align: left;
`

export const TransactionDetailsWrapper = styled(Box)`
  display: flex;
  border-top: 1px solid;
  border-color: ${get.colors('slate-2')};
  justify-content: space-between;
  padding-top: ${get.space('sm')};
  padding-bottom: ${get.space('sm')};
  ${get.media.down('md')} {
    gap: ${get.space('sm')};
    .heading {
      min-width: fit-content;
    }
  }
`
